import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { format } from "d3-format"
import CardSmall from '../../../../../../components/CockpitCards/CardSmall';
import DiaRhythmData from './DiaRhythmData'
import DiaRhythmInfo from './DiaRhythmInfo'
import RhythmChart from "./RhythmChart";


//import BmiHistory from "./BmiHIstory";
//import BmiAction from "./BmiAction";

const bmi_ref = 1;
const bmi_warning = 10;

export default function RhythmCard() {

const r_bmi = '23'

return (
<>
<CardSmall
  
headline="ECG - HEART RHYTHM"
subtext="A heart arrhythmia (uh-RITH-me-uh) is an irregular heartbeat. The heart may beat too fast or too slow. Or the pattern of the heartbeat may be inconsistent."
icon_1 = {<DiaRhythmInfo />}
icon_2 = {<DiaRhythmData />}

leftcontent={<>
     <Typography variant="number" sx={{color: 'traffic.green', 
                            ...(r_bmi > bmi_ref && {color: 'traffic.orange'}), 
                            ...(r_bmi > bmi_warning && {color: 'traffic.red'}), 
                          }}> 
                        {format(",")(r_bmi)} <Typography component="span" >% </Typography>
       </Typography>
  </>}

rightcontent={<>  <Box> <RhythmChart /></Box>   </>}  
textlines = {<>   <Typography variant="body2" sx={{ml:1, color: 'common.black',  }}> Reference:  &nbsp; Sinus </Typography> </>}

    />    
  </>
)};
  